import { NormalView } from './normalView.js';
import { StealthView } from './stealthView.js';

const TITLE_NORMAL_CELEBRITY = '名人猜猜猜';
const TITLE_NORMAL_DETECTIVE = '海龟汤';
const TITLE_STEALTH = 'AI 助手';

export class ViewManager {
  constructor(container, initialMode = false) {
    this.container = container;
    this.mode = initialMode ? 'stealth' : 'normal';

    this.normalView = new NormalView(container);
    this.stealthView = new StealthView(container);

    this.views = {
      normal: this.normalView,
      stealth: this.stealthView,
    };
  }

  init() {
    this.normalView.init();
    this.stealthView.init();
    this.applyMode();
  }

  setCallbacks(callbacks) {
    this.normalView.setCallbacks(callbacks);
    this.stealthView.setCallbacks(callbacks);
  }

  get activeView() {
    return this.views[this.mode];
  }

  setMode(mode, state, config) {
    if (this.mode === mode) return;
    const previousMode = this.mode;
    this.mode = mode;
    this.applyMode(config?.stealthTheme);
    if (previousMode === 'stealth') {
      this.stealthView.closeSettingsModal();
      this.stealthView.closePlusMenu();
      this.stealthView.closeModelMenu();
    } else {
      this.normalView.closeSettingsModal();
    }
    if (state !== undefined && config !== undefined) {
      this.render(state, config);
    }
  }

  applyMode(theme) {
    document.body.classList.remove('mode-normal', 'mode-stealth');
    document.body.classList.add(this.mode === 'stealth' ? 'mode-stealth' : 'mode-normal');
    if (this.mode === 'stealth') {
      this.stealthView.applyTheme(theme || 'dark');
    }
  }

  updateTitle(config) {
    if (this.mode === 'stealth') {
      document.title = TITLE_STEALTH;
      return;
    }
    document.title = config?.gameMode === 'detective' ? TITLE_NORMAL_DETECTIVE : TITLE_NORMAL_CELEBRITY;
  }

  // Delegate all ViewInterface methods to active view
  render(state, config) {
    this.updateTitle(config);
    this.activeView.render(state, config);
    if (this.mode === 'stealth' && config?.stealthTheme) {
      this.stealthView.applyTheme(config.stealthTheme);
    }
  }

  setLoading(loading, state, config) {
    this.activeView.setLoading(loading, state, config);
  }

  getSettings() {
    return this.activeView.getSettings();
  }

  setSettings(config) {
    this.normalView.setSettings(config);
    this.stealthView.setSettings(config);
  }

  updateSettingsSummary(config) {
    this.normalView.updateSettingsSummary(config);
    this.stealthView.updateSettingsSummary(config);
  }

  showSettingsMessage(message, type) {
    this.activeView.showSettingsMessage(message, type);
  }

  showGameMessage(message, type) {
    this.activeView.showGameMessage(message, type);
  }

  clearGameMessage() {
    this.activeView.clearGameMessage();
  }

  getQuestionInput() {
    return this.activeView.getQuestionInput();
  }

  clearQuestionInput() {
    this.activeView.clearQuestionInput();
  }

  getGuessInput() {
    return this.activeView.getGuessInput();
  }

  clearGuessInput() {
    this.activeView.clearGuessInput();
  }

  getChatInput() {
    return this.activeView.getChatInput();
  }

  clearChatInput() {
    this.activeView.clearChatInput();
  }
}

export { NormalView, StealthView };
